// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <!-- allowDelete -->
        <item-list
        :buttons="buttons"
        editRoute="deviceEdit"
        :endpoint="endpoint"
        :headers="headers"
        :loadData="loadData"
        name="Device"
        noDataText="Retrieving Data"
        :rowClass="rowClass"
        search
        ></item-list>
      </v-flex>
    </v-layout>
    <error-snackbar v-model="errorText"></error-snackbar>
    <div id="eventCanaryElement"></div>
  </v-container>
</template>
<script>
import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
import ItemList from 'vue-common/components/ItemList.vue'

import moment from 'moment'

import {ENDPOINT} from '@/shared/constants'
import {AXIOSAPI} from 'vue-common/components/requests-common'

export default {
  components: {
    ItemList,
    ErrorSnackbar
  },

  data () {
    return {
      buttons: [
        {
          text: 'Request Heartbeat',
          function: this.requestHeartbeat,
          icon: 'favorite'
        }
      ],
      endpoint: ENDPOINT + 'v1/managedevices',
      errorText: '',
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Last Heartbeat',
          value: 'date',
          function: this.formatDate
        },
        {
          text: 'Heartbeat',
          value: 'heartbeat',
          function: this.heartbeatUpdated
        }
      ],
      loadData: true
    }
  },

  mounted () {
    this.poll(this.triggerLoad, 15000)
  },

  methods: {
    formatDate: function (item) {
      return moment(item.date).format('YYYY-MM-DD hh:mm a')
    },

    heartbeatUpdated: function (item) {
      return moment(item.date) > moment().subtract(30, 'minutes')
    },

    rowClass: function (item) {
      if (moment(item.date) > moment().subtract(30, 'minutes')) {
        return 'green lighten-3'
      } else {
        return 'red lighten-3'
      }
    },

    requestHeartbeat: function (item) {
      this.loadData = false
      this.errorText = 'Heartbest request pending'
      var query = ENDPOINT + 'managedevices/' + item.id + '/heartbeat'
      AXIOSAPI.post(query, {}).then(response => {
        this.errorText = 'Heartbest request succeeded'
        this.loadData = true
      }).catch(e => {
        this.errorText = 'Heartbeat request failed: ' + e
      })
    },

    poll: function (fn, interval) {
      if (interval === null) {
        interval = 1000
      }
      var repeatFunc = function () {
        fn()
        // Use this to kill the poll if it's not visible.
        if (document.getElementById('eventCanaryElement')) {
          setTimeout(repeatFunc, interval)
        }
      }
      repeatFunc()
    },

    triggerLoad: function () {
      this.loadData = false
      // If you just directly set loaddata true the watcher isn't triggered for some reason.
      // This one ms delay solves that.
      setTimeout(() => {
        this.loadData = true
      }, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Devices.vue